import script from "./CoreUiChatHistoryMessageNavigator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoreUiChatHistoryMessageNavigator.vue?vue&type=script&setup=true&lang=ts"

import "./CoreUiChatHistoryMessageNavigator.vue?vue&type=style&index=0&id=800d95b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-800d95b2"]])

export default __exports__